import { render, staticRenderFns } from "./channel-selector.vue?vue&type=template&id=1ea86272&"
import script from "./channel-selector.vue?vue&type=script&lang=js&"
export * from "./channel-selector.vue?vue&type=script&lang=js&"
import style0 from "./channel-selector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports